const calculateRiskStatus = (collateralizationRatio, liqRatio, safetyRatio) => {
    if (collateralizationRatio == null || Number.isNaN(collateralizationRatio) || !liqRatio || !safetyRatio) {
        console.error('Error calculating risk state')
        return 1
    }
    const currentLiquidationRatioAsDecimal = collateralizationRatio / 100

    if (currentLiquidationRatioAsDecimal === 0) return 0
    if (currentLiquidationRatioAsDecimal <= liqRatio) return 4
    if (currentLiquidationRatioAsDecimal > liqRatio && currentLiquidationRatioAsDecimal <= safetyRatio) return 3
    if (currentLiquidationRatioAsDecimal > safetyRatio && currentLiquidationRatioAsDecimal <= safetyRatio * 1.2)
        return 2
    return 1
}

const calculateColor = (riskStatus) => {
    switch (riskStatus) {
        case "LIQUIDATION":
            return "#E45200";
        case "HIGH":
            return "#E45200";
        case "ELEVATED":
            return "#FCBF3B";
        case "LOW":
            return "#459d00";
        case "NO":
            return "#5DBA14";
        default:
            return "#459d00";
    }
}
const calculateRiskStatusText = (riskStatusNumeric) => {
    switch (riskStatusNumeric) {
        case 0:
            return "NO";
        case 1:
            return "LOW";
        case 2:
            return "ELEVATED";
        case 3:
            return "HIGH";
        case 4:
            return "LIQUIDATION";
        default:
            return "LOW";
    }
}

function formatDate() {
    const date = new Date();
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const month = months[date.getUTCMonth()];
    const day = date.getUTCDate();
    const year = date.getUTCFullYear();

    let hours = date.getUTCHours();
    let minutes = date.getUTCMinutes();

    // Pad single digit minute and hour values with leading zeros.
    if (hours < 10) hours = '0' + hours;
    if (minutes < 10) minutes = '0' + minutes;

    return `${month} ${day}, ${year} ${hours}:${minutes} UTC`;
}

export {
    calculateRiskStatus,
    calculateColor,
    calculateRiskStatusText,
    formatDate,
};